import { UseFormReturn } from "react-hook-form";

import { Form } from "@ps-design-system/components/Form";
import { Text } from "@ps-design-system/components/Text";

import type { AmenityOption } from "~/services/env.service";

import { USE_TYPE_SLUG } from "../ActivateListingsPage.consts";
import { ListingUseTypeConfig } from "../ActivateListingsPage.types";

import { ActivateListingFormValues } from "./ActivateListingForm.schema";
import {
  AmenitiesFields,
  CapacityFields,
  InstantBookingFields,
  PricingFields,
} from "./form-fields";

type ListingActivationFormProps = {
  amenityOptions: AmenityOption[];
  config: ListingUseTypeConfig;
  spaceCountry: string;
  form: UseFormReturn<ActivateListingFormValues>;
  isInstantBookEligible: boolean;
};

const ActivateListingForm = ({
  amenityOptions,
  config,
  spaceCountry,
  form,
  isInstantBookEligible,
}: ListingActivationFormProps) => {
  const requiredAmenityIds = config.requiredAmenityIds ?? [];
  const slug = USE_TYPE_SLUG[config.useType];

  return (
    <Form
      {...form}
      fullWidth
      className="tw-p-16"
      testId={`activate-listing-form-${slug}`}
    >
      <PricingFields spaceCountry={spaceCountry} useType={config.useType} />

      <InstantBookingFields
        useType={config.useType}
        isInstantBookEligible={isInstantBookEligible}
      />

      <CapacityFields useType={config.useType} />

      <AmenitiesFields
        amenityOptions={amenityOptions}
        requiredAmenityIds={requiredAmenityIds}
        useType={config.useType}
      />

      {form.formState?.errors?.root?.serverError && (
        <Text
          className="tw-text-red-800"
          element="p"
          typeface="body-1"
          testId={`activate-listing-form-${slug}-server-error`}
        >
          {form.formState.errors.root.serverError.message}
        </Text>
      )}
    </Form>
  );
};

export { ActivateListingForm };
